import type { B2bContractStatus } from '@Common/types/bo/b2b/contracts';

export type VoluntaryPaymentContract = {
  id: number;
  status?: B2bContractStatus;
};

export function contractIdsOpenForVoluntaryPayment(
  affiliationIds: readonly number[],
  contracts: readonly VoluntaryPaymentContract[],
): number[] {
  const openContractIds = new Set(
    contracts.filter((contract) => contract.status !== 'terminated').map((contract) => contract.id),
  );

  return affiliationIds.filter((contractId) => openContractIds.has(contractId));
}
